import DashboardLayout from '../layouts/DashboardLayout'
// import LeaderReport from '../pages/report-thpt/sale-leader-report/LeaderReport'
// import ResultReport from '../pages/report-thpt/department-report/result-report/ResultReport'
// import EmployeeReport from '../pages/report-thpt/department-report/employee-report/EmployeeReport'
// import StatusReport from '../pages/report-thpt/department-report/status-report/StatusReport'
// import ContactSourceReport from '../pages/report-thpt/department-report/contact-source-report/ContactSourceReport'
// import BestEmployeeReport from '../pages/report-thpt/best-employees-report/BestEmployee'
// import ProductGroupReport from '../pages/report-thpt/revenue-report/product-group-report/ProductGroupReport'
// import CustomerReport from '../pages/report-thpt/revenue-report/customer-report/CustomerReport'
// import PersonalReport from '../pages/report-thpt/personal-report/PersonalReport'
// import ContactRegisterReport from '../pages/report-thpt/contact-register-report/ContactRegisterReport'
// import DeliveryReport from '../pages/report-thpt/delivery-report/DeliveryReport'
// import EmployeeReportADepartment from '../pages/report-thpt/department-report/employee-report-a-department/EmployeeReportADepartment'

export const reportThptMenu = {
  path: '/report-thpt',
  component: DashboardLayout,
  name: 'ReportThpt',
  // redirect: '/leader-report',
  children: [
    {
      path: 'leader-report',
      name: 'LeaderReport',
      component: () => import (/* webpackChunkName: "about" */'../pages/report-thpt/sale-leader-report/LeaderReport.vue'),
      meta: {
        roles: ['sale-leader_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Báo cáo trưởng nhóm'
        }]
      },
    },
    {
      path: 'result-report',
      name: 'ResultReportThpt',
      component: () => import (/* webpackChunkName: "about" */'../pages/report-thpt/department-report/result-report/ResultReport.vue'),
      meta: {
        roles: ['result-report_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Báo cáo theo kết quả'
        }]
      },
    },
    {
      path: 'employee-report',
      name: 'EmployeeReportThpt',
      component: () => import (/* webpackChunkName: "about" */'../pages/report-thpt/department-report/employee-report/EmployeeReport.vue'),
      meta: {
        roles: ['human-resources-report_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Báo cáo theo nguồn lực'
        }]
      },
      query: { v: '' }
    },
    {
      path: 'status-report',
      name: 'StatusReportThpt',
      component: () => import (/* webpackChunkName: "about" */'../pages/report-thpt/department-report/status-report/StatusReport.vue'),
      meta: {
        roles: ['status-report_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Báo cáo theo trạng thái'
        }]
      },
    },
    {
      path: 'contact-source-report',
      name: 'ContactSourceReportThpt',
      component: () => import (/* webpackChunkName: "about" */'../pages/report-thpt/department-report/contact-source-report/ContactSourceReport.vue'),
      meta: {
        roles: ['contact-source-report_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Báo cáo theo nguồn contact'
        }]
      },
    },
    {
      path: 'best-employees',
      name: 'BestEmployeeReportThpt',
      component: () => import (/* webpackChunkName: "about" */'../pages/report-thpt/best-employees-report/BestEmployee.vue'),
      meta: {
        roles: ['best-employee_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Nhân viên xuất sắc'
        }]
      },
    },    
    {
      path: 'product-group',
      name: 'ProductGroupReportThpt',
      component: () => import (/* webpackChunkName: "about" */'../pages/report-thpt/revenue-report/product-group-report/ProductGroupReport.vue'),
      meta: {
        roles: ['product-group-revenue-report_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Báo cáo doanh thu theo nhóm sản phẩm'
        }]
      },
    },
    {
      path: 'customer-report',
      name: 'CustomerReportThpt',
      component: () => import (/* webpackChunkName: "about" */'../pages/report-thpt/revenue-report/customer-report/CustomerReport.vue'),
      meta: {
        roles: ['customer-revenue-report_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Báo cáo theo khách hàng'
        }]
      },
    },
    // {
    //   path: 'personal-report',
    //   name: 'PersonalReportThpt',
    //   component: () => import (/* webpackChunkName: "about" */'../pages/report-thpt/personal-report/PersonalReport.vue'),
    //   meta: {
    //     roles: ['personal-report_read'],
    //     requiresAuth: true,
    //     breadcrumb: [{
    //       title: 'Báo cáo thành tích cá nhân'
    //     }]
    //   },
    // },
    {
      path: 'delivery',
      name: 'DeliveryReportThpt',
      component: () => import (/* webpackChunkName: "about" */'../pages/report-thpt/delivery-report/DeliveryReport.vue'),
      meta: {
        roles: ['delivery-report_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Báo cáo giao hàng'
        }]
      }
    },
    {
      path: 'employee-report-fe',
      name: 'EmployeeReportThptFe',
      component: () => import (/* webpackChunkName: "about" */'../pages/report-thpt/department-report/employee-report-fe/EmployeeReport.vue'),
      meta: {
        roles: ['employee-report_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Báo cáo theo nhân viên fe'
        }]
      },
    },
    // {
    //   path: 'employee-report-:id',
    //   name: 'EmployeeReportADepartmentThpt',
    //   component: () => import (/* webpackChunkName: "about" */'../pages/report-thpt/department-report/employee-report-a-department/EmployeeReportADepartment.vue'),
    //   meta: {
    //     roles: ['employee-report-a-department_read'],
    //     requiresAuth: true,
    //     breadcrumb: [{
    //       title: 'Báo cáo theo nhân viên phòng ban trực thuộc'
    //     }]
    //   },
    // },
    {
      path: 'personal-report-fe',
      name: 'PersonalReportThptFe',
      component: () => import (/* webpackChunkName: "about" */'../pages/report-thpt/personal-report-fe/PersonalReport.vue'),
      meta: {
        roles: ['personal-report_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Báo cáo thành tích cá nhân'
        }]
      },
    },
  ],
}